/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiPickerDayStyle = (): Components<Theme>["MuiPickerDay"] => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      "&.MuiPickerDay-today:not(.Mui-selected)": {
        outline: "none",
        border: `1px dashed ${theme.palette.text.light}`,
        backgroundColor: "transparent",
      },
    }),
  },
});
